import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { AtoProcessual } from '@app/models/ato-processual.model';
import { AtoProcessualService } from '@app/services/ato-processual.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ato-processual-lista',
  templateUrl: './ato-processual-lista.component.html'
})

export class AtoProcessualListaComponent implements OnInit {

  lstAtoProcessual: AtoProcessual[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    private atoProcessualService: AtoProcessualService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.atoProcessualService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstAtoProcessual = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(atoProcessual: AtoProcessual) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o ato processual: " + atoProcessual.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.atoProcessualService.deletar(atoProcessual.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
